<template>
    <div v-if="isShowInitFilter" class="d-flex align-center justify-center" style="width: 100%">
        <DebuggerFilterCard/>
    </div>
    <div v-else class="d-flex flex-column">
        <DebuggerFilterHeader/>
        <v-layout class="layout-container">
          <ChatPreview/>
            <div class="scenario">
                <div class="layout-header d-flex align-center justify-center">Debug view</div>
                <span class="d-flex align-center justify-center empty-msg" style="height: 100%" v-if="!requestId">
                    {{$t('debugger.emptyVisualize')}}
                </span>
                <Scenario v-else/>
            </div>
            <Inspect/>
        </v-layout>
    </div>
</template>

<script>
import Inspect from '@/views/Debugger/Inspect'
import { AppEventBus, AppEventBusType } from '@/eventbus/app.eventbus'
import Scenario from '@/views/Debugger/Scenario'
import { mapActions } from 'vuex'
import DebuggerFilterCard from '../../components/DebuggerFilterCard.vue'
import DebuggerFilterHeader from '@/components/DebuggerFilterHeader.vue'
import ChatPreview from '@/views/Debugger/ChatPreview.vue'
import { sync } from 'vuex-pathify'

export default {
    name: 'Debugger',
    components: {
        ChatPreview,
        DebuggerFilterHeader,
        DebuggerFilterCard,
        Scenario,
        Inspect
    },
    data () {
        return {
            inspectActive: true,
            isShowChatPreview: true
        }
    },
    mounted () {
    },
    computed: {
        isShowInitFilter () {
            return !this.$route.query.sender_id
        },
        requestId: sync('debug/request_id')
    },
    methods: {
        ...mapActions('ui', ['openModal']),
        onViewInspect (payload) {
            this.inspectActive = true
            AppEventBus.emit(AppEventBusType.VIEW_INSPECT, payload)
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-container {
    background-color: #FAFAFA;
    height: calc(100vh - 122px);

    .scenario {
        flex-grow: 1;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
    }
    .layout-header {
        background-color: #F4F4F4;
        padding: 4px 10px;
        font-weight: bold;
        color: #7B7B7B;
    }
}
.empty-msg {
    color: #7B7B7B;
}
</style>
